//import { db } from '../firebase';

export const addCheck = (id, name, email, records, sends, checks, all_check, callback) => {
  let check_flg = false
  for (let i = 0; i < sends.length; i++) {
    if (sends[i].id === id) {
      sends.splice(i, 1);
      checks[id] = false
      check_flg = true
    }
  }
  if (check_flg === false) {
    sends.push({id: id, name: name, email: email});
    checks[id] = true
  }

  if (sends.length === 0) {
    all_check = "false"
  } else if (sends.length === records.length) {
    all_check = "true"
  } else {
    all_check = "both"
  }

  callback({ sends: sends, checks:checks, all_check: all_check })
}

export const allCheck = (all_check, records, callback) => {
  var check = true
  if (all_check === "false") {
    check = true
    all_check = "true"
  } else {
    check = false
    all_check = "false"
  }
  var sends = []
  var checks = {}
  for(let i in records) {
    checks[records[i].id] = check
    let name = records[i].lastName
    if (records[i].family_name) {
      name = records[i].family_name + " " + records[i].first_name
    }
    sends.push({id: records[i].id, name: name, email: records[i].email});
  }
  if (check === false) {
    sends = []
  }

  callback({ sends: sends, checks: checks, all_check: all_check })
}

export const deleteRecord = (name, ref, redirect_uri, db) => {
  var text = "レコードを削除しますか？"
  if (name) {
    text = 'レコード「' + name + '」を削除しますか？'
  }
  if (window.confirm(text)) {

    var data = {
      delete: true,
      deletedAt: Date.now()
    }

    db.ref(ref).update(data).then(function() {
      // Update successful.
      window.location.href = redirect_uri;
    }).catch(function (error) {
      // An error happened.
    });
  }
}

export const restoreRecord = (name, ref, redirect_uri, db) => {
  var text = "レコードを復元しますか？"
  if (name) {
    text = 'レコード「' + name + '」を復元しますか？'
  }
  if (window.confirm(text)) {

    var data = {
      delete: null
    }

    db.ref(ref).update(data).then(function() {
      // Update successful.
      window.location.href = redirect_uri;
    }).catch(function (error) {
      // An error happened.
    });
  }
}
